import { Box, Icon, Typography } from "@mui/material";
import React, { useState } from "react";
import { CButton } from "./StyledComponent";
import ToggleContainer from "./ToggleContainer";

function FilterContainer({ sxRoot = {}, defaultValue = true, ...props }) {
  const [flag, setFlag] = useState(defaultValue);
  const rotate = flag ? 0 : "-180deg";

  return (
    <Box sx={{ ...sxRoot, borderRadius: "0.3rem" }}>
      <CButton
        onClick={() => setFlag(!flag)}
        variant="text"
        fullWidth
        bg_hover_color="var(--primary_color)"
        sx={{ "&:hover": { color: "white" }, zIndex: '10' }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: 'center', width: "100%" }}>
          <Typography variant="body1">filter</Typography>
          <Icon sx={{ rotate, transition: "all 200ms" }}>{`keyboard_arrow_down`}</Icon>
        </Box>
      </CButton>
      <ToggleContainer open={flag} wrapperStyle={{ paddingTop: "0.5rem" }}>
        {props.children}
      </ToggleContainer>
    </Box>
  );
}

export default FilterContainer;
